/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.fabricantes': 'Fabricantes',
  'fabricantes.agregarFabricantes': 'Crear Fabricantes',
  'fabricantes.modificarFabricantes': 'Editar Fabricantes',
  'fabricantes.fabricanteId': 'Fabricante Id',
  'fabricantes.empresaId': 'Empresa Id',
  'fabricantes.fabricanteDescripcion': 'Fabricante Descripción',
  'fabricantes.VerFabricantes': 'Ver Fabricantes',
};
